<template>
    <el-dialog
        class="config_field_dialog"
        title="字段配置"
        :visible.sync="openConfigFieldDialog"
        top="4%"
        width="770px"
        :before-close="closeDialog">
        <el-table
            :data="tableData"
            ref="multipleTable"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            height="400"
            style="width: 100%; font-size: 12px;">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="fieldName"
                width="170"
                label="字段名">
            </el-table-column>
            <el-table-column
                prop="fieldCode"
                label="字段">
            </el-table-column>
            <el-table-column
                prop="requiredFlag"
                label="是否必填">
                <template slot-scope="scope">
                    <el-select v-model="tableData[scope.$index].requiredFlag">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                prop="disabledFlag"
                label="是否置灰">
                <template slot-scope="scope">
                    <el-select v-model="tableData[scope.$index].disabledFlag">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <!-- <el-table-column
                prop="editorType"
                label="编辑器类型">
            </el-table-column> -->
            <!-- <el-table-column
                prop="editorOption"
                label="编辑器属性">
                <template slot-scope="scope">
                    <el-input v-model="tableData[scope.$index].editorOption"></el-input>
                </template>
            </el-table-column> -->
        </el-table>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" :loading="confirmLoading" @click="confirmDialog">确 定</el-button>
  </span>
    </el-dialog>

</template>

<script>
import _ from '@/components/lots/utils';
import { BASE_CONFIG_FIELDS } from '../../../../constant/constant';

export default {
    name: 'config-field-dialog',
    components: {},
    props: {
        openConfigFieldDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        fieldData: {
            type: Array,
            default() {
                return [];
            }
        },
        overseaSwitch: {
            type: Boolean,
            default() {
                return true;
            }
        },
    },
    data() {
        return {
            loading: false,
            confirmLoading: false,
            options: [
                {
                    label: '是',
                    value: 0
                },
                {
                    label: '否',
                    value: 1
                }
            ],
            editorTypeOptions: [
                {
                    label: 'input',
                    value: 'input'
                },
                {
                    label: 'date',
                    value: 'date'
                },
                {
                    label: 'select',
                    value: 'select'
                }
            ],
            tableData: [
                // {
                //     fieldName: '供应商编码',
                //     fieldCode: '10'
                // },
                // {
                //     fieldName: '客户编码',
                //     fieldCode: '20'
                // },
                // {
                //     fieldName: '供应商类型',
                //     fieldCode: '30'
                // }
            ],
            multipleSelection: [],
            selectedFieldCodes: []
        };
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog', false);
        },
        confirmDialog() {
            this.confirmLoading = true;
            this.$emit('confirmDialog', { data: _.clone(this.multipleSelection), close: false });
        },
        clear() {
            this.tableData.forEach(tabItem => {
                tabItem.requiredFlag = '';
                tabItem.disabledFlag = '';
                tabItem.editorType = '';
                tabItem.editorOption = '';
                if (tabItem.id) {
                    tabItem.id = null;
                }
            });
            this.multipleSelection = [];
            this.selectedFieldCodes = [];
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        toggleRowSelection() {
            const selectedRow = [];
            this.tableData.forEach(item => {
                if (this.selectedFieldCodes.indexOf(item.fieldCode) >= 0) {
                    selectedRow.push(item);
                    this.$refs.multipleTable.toggleRowSelection(item);
                }
            });
            this.loading = false;
        }
    },
    watch: {
        openConfigFieldDialog(val) {
            if (val) {
                this.loading = true;
            } else {
                this.clear();
                this.confirmLoading = false;
            }
        },
        fieldData(val) {
            this.tableData = BASE_CONFIG_FIELDS.filter(item => {
                // 根据开关过滤开关控制的字段
                return this.overseaSwitch || (!this.overseaSwitch && !item.overseaSwitch)
            }).map(item => {
                return {
                    fieldName: item.name,
                    fieldCode: item.code,
                    editorType: item.type
                };
            });
            this.tableData = _.clone(this.tableData.map(tableItem => {
                val.forEach(fieldItem => {
                    if (tableItem.fieldCode === fieldItem.fieldCode) {
                        const { fieldName } = tableItem;
                        tableItem = fieldItem;
                        tableItem.fieldName = fieldName;
                        if(fieldItem.fieldCode==="supplierSourceWay"){
                            tableItem.editorType = 'select';
                        }
                        this.selectedFieldCodes.push(fieldItem.fieldCode);
                    }
                });
                return tableItem;
            }));
            const TOGGLE_DELAY = 2000;
            setTimeout(() => {
                this.toggleRowSelection();
            }, TOGGLE_DELAY);
        }
    }
};
</script>

<style lang="less">
</style>
